import type { FC } from "react";
import { useEffect, useState } from "react";
import { Button } from "@/components/button/Button";
import classNames from "classnames";
import styles from "./ScrollToTopButton.module.scss";
import useTranslation from "next-translate/useTranslation";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";

interface ScrollToTopButtonProps {
  scrollToTopThreshHold?: number;
  className?: string | undefined;
}
export const ScrollToTopButton: FC<ScrollToTopButtonProps> = (props) => {
  const { className, scrollToTopThreshHold = 300 } = props;

  const { t } = useTranslation("web-payments");
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const scrollToTop = () => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (typeof window !== undefined) {
      window.scroll({ top: 0, behavior: "smooth" });
    } else {
      return;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= scrollToTopThreshHold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollToTopThreshHold]);

  return isVisible ? (
    <Button
      className={classNames("title-8-medium", styles.button, className)}
      variant={"fill"}
      onClick={() => {
        scrollToTop();
      }}
    >
      {t("BACK_TO_TOP")}
      <ImageWithFallback
        className={styles.button__icon}
        width={24}
        height={24}
        alt=""
        src="https://images.onefootball.com/cw/icons/arrow-right-dark.svg"
      />
    </Button>
  ) : null;
};
